import OrderRequestCartItem from './OrderRequestCartItem'

export default class OrderRequestCart {
  constructor ({ items }) {
    this.items = items.map(i => new OrderRequestCartItem(i))
  }
}
